import { all } from "redux-saga/effects";
import customerSaga from "./customer/saga";
import paymentSaga from "./payment/saga";
import UserPrefSage from "./auth/saga";

export default function* rootSaga() {
  yield all([customerSaga(), paymentSaga(), UserPrefSage()]);
}
